export default __webpack_public_path__ + "static/bg-img-04ec2a7bb6c390682fb5dc78ba341946.png";